module.exports = __webpack_public_path__ + "static/media/a11_lighting.f0e07384.png";